// extracted by mini-css-extract-plugin
export var required = "_fk-0";